// Age gate helpers. Reads the users/{uid}.birthday field — an ISO date string
// (YYYY-MM-DD), the same field already used by Profile/Account settings.
export const MIN_SIGNUP_AGE = 13;
export const MIN_FAMILY_ADMIN_AGE = 18;

export function getAge(dateOfBirth) {
  if (!dateOfBirth) return null;
  const dob = new Date(dateOfBirth);
  if (Number.isNaN(dob.getTime())) return null;

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }
  return age;
}

// Validates a YYYY-MM-DD date of birth isn't in the future or implausibly old.
export function isPlausibleDateOfBirth(dateOfBirth) {
  const dob = new Date(dateOfBirth);
  if (Number.isNaN(dob.getTime())) return false;
  const age = getAge(dateOfBirth);
  return age !== null && age >= 0 && age <= 120;
}
